<template>

    <div class="col-md-6  border-0">
        <div class="ibox dasboard_graph">
            <div class="ibox-title dashboard_title company-form-box-title pf-contribution">
                <div class="clearfix">
                    <div class="left_container">
                        <ul class="title_list">
                            <li class="title-text">Payroll Quick Stat</li>
                            <li class="devider_list"><span class="devider"></span></li>
                            <li class="legend_list total_earnings"><span class="text">Total Earnings</span></li>
                            <li class="legend_list total_deductions"><span class="text">Total Deductions</span></li>
                            <li class="legend_list net_salary"><span class="text">Net Salary</span></li>
                        </ul>
                    </div>
                    <div class="right_container">
                        <template v-if="payrunsfiscalyear.length > 0">
                            <b-form-select class="dasboard_graph_select" v-model="search.fiscal_year"  @change="setSearch()">
                                <option value="null">Select Fiscal Year</option>
                                <option v-for='fyear in payrunsfiscalyear' :value='fyear.fiscal_year'  >{{fyear.fiscal_year }}</option>
                            </b-form-select>
                        </template>
                    </div>

                </div>
            </div>
            <div class="ibox-content">

                <template v-if="quick_start_load == false">
                    <template v-if="barFiscalYearDatas != null ">
                        <bar-chart :chart-data="barFiscalYearDatas" :options= "options" :styles="myStyles"  class="p-2" ></bar-chart>
                    </template>
                </template>
                <template v-else>
                    <div class="trz_loader">
                        {{load_data}}
                        </br>
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo text-center" width="100px"/>
                    </div>
                </template>

            </div>
        </div>
    </div>

</template>

<script>
    import moment from 'moment';
    export default{

        mounted() {

        },
        props: ['payrunsfiscalyear'],
        components: {

        },
        data(){

            return {
                search:{employee_id:'', pay_slip_name:'', pay_slip_ref:'', fiscal_year:null, month:''},
                barFiscalYearDatas: null,
                options:null,
                myStyles:null,
                payrunsapproved:[],
                quick_start_load:false,
                load_data:'Please hold tight! We are generating your payroll stat!',
                draft_payruns:[],

            }
        },
        methods:{
            setSearch: function(pageflg)
            {
                this.getpayrunsapproved();
            },
            getpayrunsapproved: function()
            {


                this.quick_start_load = true;
                //console.log('getpayrunsapproved 0');
                axios.get(this.$api_url+'/list-payruns/1' , {
                params: {
                    search_query: this.search,

                }
                }).then(function(response){
                    this.payrunsapproved = response.data.data;

                    let total_earnings = [];
                    let deduction = [];
                    let net = [];
                    let month = [];
                    let year = [];



                    for (let x in this.payrunsapproved) {

                        let total_earnings_draft = 0;
                        let deduction_draft = 0;
                        let net_draft = 0;


                        for (let y in this.draft_payruns.year) {
                            if(this.draft_payruns.year[y] == this.payrunsapproved[x].year && this.draft_payruns.month[y] == this.payrunsapproved[x].month){
                                total_earnings_draft = total_earnings_draft + this.draft_payruns.total_earnings[y] ;
                                deduction_draft = deduction_draft + this.draft_payruns.deduction[y] ;
                                net_draft = net_draft + this.draft_payruns.net[y] ;

                            }

                        }

                        total_earnings_draft = total_earnings_draft + parseFloat(this.payrunsapproved[x].total_earnings.replaceAll(',', ''));
                        deduction_draft = deduction_draft + parseFloat(this.payrunsapproved[x].deductions.replaceAll(',', ''));
                        net_draft = net_draft + parseFloat(this.payrunsapproved[x].total_pay.replaceAll(',', ''));




                        var month_x = this.payrunsapproved[x].month.replaceAll(',', '');
                        if(month.indexOf(month_x) !== -1)
                        {
                            var inx = month.indexOf(month_x);
                            total_earnings[inx] = total_earnings[inx] +total_earnings_draft;
                            deduction[inx] = deduction[inx] +deduction_draft;
                            net[inx] = net[inx] +net_draft;

                        }
                        else
                        {
                            month.push(this.payrunsapproved[x].month.replaceAll(',', ''));
                            total_earnings.push(total_earnings_draft);
                            deduction.push(deduction_draft);
                            net.push(net_draft);
                            year.push(this.payrunsapproved[x].year);
                        }
                        /*total_earnings.push(total_earnings_draft);
                        deduction.push(deduction_draft);
                        net.push(net_draft);

                        month.push(this.payrunsapproved[x].month.replaceAll(',', ''));
                        year.push(this.payrunsapproved[x].year);*/

                    }


                    month.reverse();
                    total_earnings.reverse();
                    deduction.reverse();
                    net.reverse();
                    year.reverse();




                    this.barFiscalYearData(total_earnings,deduction,net,month);

                    this.quick_start_load = false;



                }.bind(this));


            },
            barFiscalYearData: function(earning,deduction,net,month){


                this.barFiscalYearDatas={

                    labels: month,
                    datasets: [
                        {
                            label: 'Total Earnings',
                            data: earning,

                            borderColor: 'rgba(140,203,212)',
                            backgroundColor:'rgba(140,203,212,1)',
                            borderWidth: 3,
                            borderRadius: Number.MAX_VALUE,
                            borderSkipped: false,

                        },
                        {
                            label: 'Total Deductions',
                            data:deduction,

                            borderColor: 'rgba(228,173,177)',
                            backgroundColor:'rgba(228,173,177,1)',
                            borderWidth: 3,
                            borderRadius: 10,
                            borderSkipped: false,
                        },
                        {
                            label: 'Net Salary',
                            data: net,

                            borderColor: 'rgba(139,205,175)',
                            backgroundColor:'rgba(139,205,175,1)',
                            borderWidth: 3,
                            borderRadius: 10,
                            borderSkipped: false,
                        },
                    ]

                };



                this.options= {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                stepSize: 2000000,
                                responsive:true,
                                mode: 'index',
                                bodySpacing: 5,
                                bodyFontFamily: 'Poppins',
                                bodyFontFamily: 'Poppins',
                                bodyFontSize: 12,
                                callback: function(value, index, values) {
                                    return Number(value).toLocaleString()  ;
                                }

                                }

                        }]
                    },
                    tooltips: {
                        mode: 'index',
                        bodySpacing: 5,
                        bodyFontFamily: 'Poppins',
                        bodyFontSize: 12,
                        callbacks: {
                            label: function(tooltipItem, chartData)  {

                                return Number(tooltipItem.value).toLocaleString();
                            },

                        }
                    }
                };

                this.myStyles={
                    height: '40%',
                    width: '100%',
                    position: 'relative',

                };

            },

        },
        created: function()
        {
            if(this.payrunsfiscalyear.length > 0)
            {
                this.search.fiscal_year=this.payrunsfiscalyear[0].fiscal_year;

                // Abdullah after live added this
                 this.getpayrunsapproved();
            }
        }
    }
</script>
